export const DATE_FORMAT = 'D.M.YYYY';

export const PAYMENT_METHOD_WITHOUT_PAYMENT = 'WITHOUT_PAYMENT';

export const TAB_OCCUPATIONS = 'OCCUPATIONS';
export const TAB_ROOMS = 'ROOMS';

export const TAB_OCCUPATIONS_DAYS = 24;


// WEBPACK FOOTER //
// ./src/constants.js